"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
exports.CSS = {
    container: 'c-LocationInput',
    label: 'c-LocationInput__label',
    tableInputs: 'c__LocationInput__tableInputs',
    error: 'c-LocationInput__error',
    isCompact: 'c-input--is-compact',
    unit: 'c-unit',
    MDL: {
        error: 'mdl-textfield__error'
    }
};
exports.Style = (_a = {},
    _a[exports.CSS.container] = {
        width: '100%',
        display: 'block',
        'align-items': 'center'
    },
    _a[exports.CSS.tableInputs] = {
        width: '100%',
        border: '0px'
    },
    _a[exports.CSS.error] = {
        visibility: 'visible',
        position: 'relative'
    },
    _a);
//# sourceMappingURL=location.input.style.js.map